<template>
  <div v-if="preloadDone">
    <div class="text-right mb-2">
      <b-button
        variant="info"
        class="text-white"
        size="sm"
        @click="clearFilters()"
        >Limpar filtros</b-button
      >
    </div>
    <kendo-datasource
      ref="datasource1"
      :transport="gridTransport"
      schema-model-id="id"
      :schema-model-fields="schemaModelFields"
      :schema-total="schemaTotal"
      :schema-data="'data'"
      :page-size="10"
      :server-paging="true"
      :server-filtering="true"
      :server-sorting="true"
      :schema-aggregates="schemaAggregates"
      :server-aggregates="serverAggregates"
      :aggregate="aggregate"
      :page="options.dataSource.page"
      :filter="options.dataSource.filter"
      :sort="options.dataSource.sort"
    >
    </kendo-datasource>
    <kendo-grid
      ref="mygrid"
      :height="height"
      :data-source-ref="'datasource1'"
      :pageable="pageable"
      :filterable="filterable"
      :sortable="sortable"
      :columns="columns"
      :scrollable="true"
      :editable="editable"
      :toolbar="toolbar"
      v-on:databound="finalDataBound"
      :reorderable="true"
      :resizable="true"
      :column-menu="true"
    >
    </kendo-grid>
  </div>
</template>

<script>
import Vue from "vue";
import kendo from "@progress/kendo-ui/js/kendo.all.js"; // eslint-disable-line no-unused-vars
import {
  KendoGrid,
  KendoGridInstaller,
} from "@progress/kendo-grid-vue-wrapper";
import {
  KendoDataSource,
  KendoDataSourceInstaller,
} from "@progress/kendo-datasource-vue-wrapper";
// var jQuery = require('jquery')

Vue.use(KendoDataSourceInstaller);
Vue.use(KendoGridInstaller);

export default {
  props: [
    "name",
    "dataBound",
    "schemaModelFields",
    "url",
    "columns",
    "preload",
    "sortable",
    "pageable",
    "filterable",
    "height",
    "serverAggregates",
    "aggregate",
    "editable",
    "requestmethod",
    "nomemory",
  ],
  components: {
    KendoGrid,
    KendoDataSource,
  },
  data() {
    return {
      preloadDone: false,
      gridTransport: this.getTransport(),
      schemaTotal: this.getTotal,
      schemaAggregates: this.getAggregates,
      toolbar: null,
      finalDataBound: null,
      options: {
        dataSource: {
          page: 1,
          sort: null,
          filter: null,
        },
      },
    };
  },
  methods: {
    removeFilter: function (filterField) {
      var gridData = this.$refs.mygrid.kendoWidget();
      var currFilterObj = gridData.dataSource.filter();

      // get current set of filters, which is supposed to be array.
      // if the oject we obtained above is null/undefined, set this to an empty array
      var currentFilters = currFilterObj ? currFilterObj.filters : [];

      // iterate over current filters array. if a filter for "filterField" is already
      // defined, remove it from the array
      // once an entry is removed, we stop looking at the rest of the array.
      if (currentFilters && currentFilters.length > 0) {
        for (var i = 0; i < currentFilters.length; i++) {
          if (currentFilters[i].field === filterField) {
            currentFilters.splice(i, 1);
            break;
          }
        }
      }
      gridData.dataSource.filter({
        logic: "and",
        filters: currentFilters,
      });
    },
    applyMultipleFilter: function (filterField, filterValue, logic = "and") {
      var gridData = this.$refs.mygrid.kendoWidget();
      // get currently applied filters from the Grid.
      var currFilterObj = gridData.dataSource.filter();
      console.log(currFilterObj);
      // get current set of filters, which is supposed to be array.
      // if the oject we obtained above is null/undefined, set this to an empty array
      var currentFilters = currFilterObj ? currFilterObj.filters : [];

      // iterate over current filters array. if a filter for "filterField" is already
      // defined, remove it from the array
      // once an entry is removed, we stop looking at the rest of the array.
      if (currentFilters && currentFilters.length > 0) {
        for (var i = 0; i < currentFilters.length; i++) {
          if (currentFilters[i].field === filterField) {
            currentFilters.splice(i, 1);
            break;
          }
        }
      }
      // if "filterValue" is "0", meaning "-- select --" option is selected, we don't
      // do any further processing. That will be equivalent of removing the filter.
      // if a filterValue is selected, we add a new object to the currentFilters array.
      for (let i = 0; i < filterValue.length; i++) {
        currentFilters.push({
          field: filterField,
          operator: "eq",
          value: filterValue[i],
        });
      }
      // finally, the currentFilters array is applied back to the Grid, using "and" logic.
      gridData.dataSource.filter({
        logic: logic,
        filters: currentFilters,
      });
    },
    applyFilter: function (filterField, filterValue, logic = "and") {
      var gridData = this.$refs.mygrid.kendoWidget();
      // get currently applied filters from the Grid.
      var currFilterObj = gridData.dataSource.filter();
      console.log(currFilterObj);
      // get current set of filters, which is supposed to be array.
      // if the oject we obtained above is null/undefined, set this to an empty array
      var currentFilters = currFilterObj ? currFilterObj.filters : [];

      // iterate over current filters array. if a filter for "filterField" is already
      // defined, remove it from the array
      // once an entry is removed, we stop looking at the rest of the array.
      if (currentFilters && currentFilters.length > 0) {
        for (var i = 0; i < currentFilters.length; i++) {
          if (currentFilters[i].field === filterField) {
            currentFilters.splice(i, 1);
            break;
          }
        }
      }
      // if "filterValue" is "0", meaning "-- select --" option is selected, we don't
      // do any further processing. That will be equivalent of removing the filter.
      // if a filterValue is selected, we add a new object to the currentFilters array.
      currentFilters.push({
        field: filterField,
        operator: "eq",
        value: filterValue,
      });
      // finally, the currentFilters array is applied back to the Grid, using "and" logic.
      gridData.dataSource.filter({
        logic: logic,
        filters: currentFilters,
      });
    },
    clearFilters: function () {
      var grid = this.$refs.mygrid.kendoWidget();
      grid.dataSource.filter({});
    },
    reload() {
      var grid = this.$refs.mygrid.kendoWidget();
      grid.dataSource.read();
    },
    getTransport() {
      var v = this;
      var requestMethod;
      if (typeof this.requestmethod !== "undefined") {
        requestMethod = this.requestmethod;
      } else {
        requestMethod = "GET";
      }
      console.log(this.requestmethod);
      console.log(requestMethod);
      return {
        read: {
          url: v.axios.defaults.baseURL + this.url,
          type: requestMethod,
          beforeSend(req) {
            req.setRequestHeader("Authorization", "Bearer " + v.$auth.token());
          },
        },
        update: {
          url: v.axios.defaults.baseURL + this.url + "/gridEdit",
          dataType: "json",
          beforeSend(req) {
            req.setRequestHeader("Authorization", "Bearer " + v.$auth.token());
          },
          type: "PUT",
        },
        parameterMap: function (data, type) {
          if( typeof data.filter != "undefined" && data.filter != null && typeof data.filter.filters != 'undefined') {
            const filters = data.filter.filters;
            data.filter.filters = v.converDatesInArray(filters);
          }
          return data
        }
      };
    },
    converDatesInArray(filters) {
      return filters.map(element => {
        if(typeof element.filters != 'undefined') {
          element.filters = this.converDatesInArray(element.filters);
        } else if(element.value instanceof Date) {
          element.value = this.formatDate(element.value);
        }
        return element;
      });
    },
    formatDate(date) {
      var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2)
          month = '0' + month;
      if (day.length < 2)
          day = '0' + day;

      return [year, month, day].join('-');
    },
    getTotal(response) {
      return response.meta.pagination.total;
    },
    getAggregates(response) {
      return response.meta.aggregates;
    },
    setColumnsData(data, field) {
      for (var i = 0; i < this.columns.length; i++) {
        if (this.columns[i].field === field) {
          this.columns[i].values = data;
        }
      }
    },
  },
  created() {
    var that = this;
    console.log(this.nomemory !== true);
    if (this.nomemory !== true) {
      console.log("restoring options");
      if (localStorage[this.name + "options"]) {
        this.options = JSON.parse(localStorage[this.name + "options"]);
      }
    }
    var apiPreloads = [];
    if (
      typeof this.preload !== "undefined" &&
      this.preload != null &&
      this.preload.length > 0
    ) {
      for (var i = 0; i < this.preload.length; i++) {
        apiPreloads.push(this.preload[i].api);
      }
      this.axios
        .all(apiPreloads.map((l) => this.axios.get(l)))
        .then(
          that.axios.spread(function () {
            for (var i = 0; i < that.preload.length; i++) {
              that.setColumnsData(
                arguments[i].data.data,
                that.preload[i].field
              );
            }
            that.preloadDone = true;
          })
        )
        .catch((response) => {
          console.error("error loading foreigns", response);
        });
    } else {
      that.preloadDone = true;
    }
    if (this.editable) {
      this.toolbar = ["save", "cancel"];
    }
    if (typeof this.dataBound == "undefined") {
      this.finalDataBound = function () {};
    } else {
      this.finalDataBound = this.dataBound;
    }
  },
  beforeDestroy() {
    if (this.nomemory !== true) {
      try {
        var grid = this.$refs.mygrid.kendoWidget();
        localStorage[this.name + "options"] = kendo.stringify(
          grid.getOptions()
        );
      } catch (error) {}
    }
  },
};
</script>
